import React, { FC, useState } from "react";
import { StandardContextProps } from "@/types/contextTypes";
import { ProjectDataType, ShipDataType, StudyDataType } from "@/types/apiTypes";
import { HomePageContext } from "./HomePageContext";

export const HomePageContextProvider: FC<StandardContextProps> = ({
  children,
}) => {
  const [ships, setShips] = useState<ShipDataType[]>([]);
  const [studies, setStudies] = useState<StudyDataType[]>([]);
  const [projects, setProjects] = useState<ProjectDataType[]>([]);

  return (
    <HomePageContext.Provider
      value={{ ships, setShips, studies, setStudies, projects, setProjects }}
    >
      {children}
    </HomePageContext.Provider>
  );
};
